export default function SummaryForm() {
  return (
    <div style={{ background: "yellow" }}>
  <h1>Summary Page Loaded</h1>
</div>
    
  );
}
